import { all, call } from 'redux-saga/effects';
import block from './block/blockSagas';

export default function* blockSaga() {
	yield all([call(block)]);
}
